import ResultsBadge from './ResultsBadge';

export default ResultsBadge;
